<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">合同誌・アンソロジー一覧
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-for="item in Anthologies" :key="item.id">
      <section class="section section-lg">
        <div class="container pt-lg">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ item.attributes.Name }}</h2>
              <p class="lead">{{ item.attributes.SubTitle }}</p>
              <h3>{{ item.attributes.Lead }}</h3>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <p v-html="item.attributes.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.attributes.Image.data.attributes.url class="img-fluid">
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-8">
              <h4>書籍情報</h4>
              <div v-if="item.attributes.DisplayCPName != null">
                <h5>{{ item.attributes.DisplayCPName }}{{ item.attributes.Type }}</h5>
              </div>
              <div v-else>
                <h5>{{ item.attributes.MainCharacter }}{{ item.attributes.Type }}</h5>
              </div>
              <h5>サイズ：{{ item.attributes.Size }} {{ item.attributes.Pages }}P</h5>
              <h5 v-if="item.attributes.OtherAuthors['表紙']">表紙：{{ item.attributes.OtherAuthors['表紙'] }}</h5>
              <h5>発行日：{{ item.attributes.PublishDate }}（{{ item.attributes.EventName }}）</h5>
              <h5>価格：{{ item.attributes.Price }} 円（イベント頒布価格）</h5>
              <hr>
              <div class="btn-wrapper">
                  <span v-if="item.attributes.OnSaleWithPaper == true && item.attributes.OnlineStore">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-cart">
                        BOOTHで購入
                      </base-button>
                    </a>
                  </span>
                <span v-else-if="item.attributes.OnSaleWithPaper == true && !item.attributes.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="fa fa-clock-o" disabled>
                      BOOTH準備中
                    </base-button>
                  </span>
                <span v-else-if="item.attributes.OnSaleWithDigital == true">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-tablet-button">
                        BOOTHで購入(電子版)
                      </base-button>
                    </a>
                  </span>
                <span v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </span>
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="item.attributes.IsAnthology == true">
                <h4>参加者</h4>
                <b-table :items="item.attributes.OtherAuthors['参加者']"
                         :fields="['name', 'twitter', 'pixiv', 'web']"
                         thead-class="d-none" small>
                  <template #cell(name)="data">
                    <h5>{{ data.value }}</h5>
                  </template>
                  <template #cell(twitter)="data">
                    <a v-if="data.value" class="ic-sns ic-twitter ic-sm" :href="data.value" target="_blank"></a>
                  </template>
                  <template #cell(pixiv)="data">
                    <a v-if="data.value" class="ic-sns ic-pixiv ic-sm" :href="data.value" target="_blank"></a>
                  </template>
                  <template #cell(web)="data">
                    <a v-if="data.value" class="ic-sns ic-sm ic-web" :href="data.value" target="_blank"></a>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
     </section>
    </div>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "anthologies",
  components: {
    moment
  },
  data() {
    return{
      Anthologies: [],
      Events: []
    };
  },
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - 合同誌・アンソロジー一覧' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」が発行している合同誌・アンソロジー一覧' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
  created() {
    moment.locale('ja')
    this.getEvents()
    this.getBooks()
  },
  methods: {
    getBooks() {
      this.axios.get('/strapi/api/book-informations?populate=%2A&sort[0]=PublishDate%3Adesc&filters[IsAnthology][$eq]=true')
        .then(response =>{
          this.Anthologies = response.data.data
          this.Anthologies.forEach(function (value, index, array){
            if(value['attributes']['EventId'] !== null){
              if(this.Events.find(el => Number(el.id) == Number(value['attributes']['EventId'])) != null) {
                array[index]['attributes']['EventName'] = this.Events.find(el => el.id == value['attributes']['EventId']).attributes.Name
                array[index]['attributes']['EventInfo'] = this.Events.find(el => el.id == value['attributes']['EventId']).attributes
              }
            }
            switch (value['attributes']['Size']){
              case 'Duodecimo':
                array[index]['attributes']['Size'] = "四六判";
                break;
              case 'Paperback':
                array[index]['attributes']['Size'] = "文庫";
                break;
              case 'Others':
                array[index]['attributes']['Size'] = "その他";
                break;
              default:
                break;
            }
            switch (value['attributes']['Type']){
              case 'Normal':
                array[index]['attributes']['Type'] = "小説本";
                break;
              case 'Short':
                array[index]['attributes']['Type'] = "短編小説本";
                break;
              case 'ShortStories':
                array[index]['attributes']['Type'] = "短編集";
                break;
              case 'Series':
                array[index]['attributes']['Type'] = "小説本(シリーズ)";
                break;
              case 'LongStory':
                array[index]['attributes']['Type'] = "中長編小説本";
                break;
              case 'StoryAnthology':
                array[index]['attributes']['Type'] = "小説合同誌・アンソロジー";
                break;
              case 'StoryComicsAnthology':
                array[index]['attributes']['Type'] = "小説漫画合同誌・アンソロジー";
                break;
              case 'AllTypeAnthology':
                array[index]['attributes']['Type'] = "合同誌・アンソロジー";
                break;
              case 'Others':
                array[index]['attributes']['Type'] = value['attributes']['OtherType'];
                break;
              default:
                break;
            }
            array[index]['attributes']['PublishDate'] = moment(value['attributes']['PublishDate']).format('YYYY/MM/DD')
            if (array[index]['attributes']['Description'] !== null){
              array[index]['attributes']['Description'] = value['attributes']['Description'].replace(/\r?\n/g, '<br >');
            }
            if(array[index]['attributes']['Image']['data']){
              array[index]['attributes']['Image']['data']['attributes']['url'] = '/strapi' + value['attributes']['Image']['data']['attributes']['url']
            }
          }, this)
        }).catch(error =>{
          console.log(error)
      })
    },
    getEvents() {
      this.axios.get('/strapi/api/event-informations?pagination[pageSize]=50')
          .then(response =>{
            this.Events = response.data.data
          }).catch(error =>{
        console.log(error)
      })
    },
  }
};
</script>
<style>
</style>
